import { createApp } from "vue";
import App from "./App.vue";
import "@/utils/extenstions";
import router, { setupRouter } from "./router";
import { setupAntd, setupDirectives } from "@/plugins";
import { setupStore } from "@/store";
import { SvgIcon } from "@/components/svg-icon";

const app = createApp(App);

// 注册全局常用的ant-design-vue组件
setupAntd(app);
// 注册全局自定义组件,如：<svg-icon />
app.component(SvgIcon.name, SvgIcon);
// 注册全局自定义指令，如：v-resize
setupDirectives(app);
// 挂载vuex状态管理
setupStore(app);
// 挂载路由
setupRouter(app);
// 路由准备就绪后挂载APP实例
router.isReady().then(() => app.mount("#app"));
